if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // インドの森 2026-09-05: 日本のみ配送の商品（サンタナ4商品）は、配送先の国が日本以外だと
      // Shopify が購入不可にし、カート追加は「'商品名'は既に売り切れました。」とだけ返す（422の定型文）。
      // 在庫切れと誤解されるので理由を添え、配送先を日本に設定し直すボタンを出す。
      // 配送先が日本なのに失敗する場合は、市場切替でカートセッションが壊れるShopify側の既知不具合
      // （シークレットでは再現せず cookie 削除で解消）に当たっている可能性があるため、その旨を案内する。
      inmShippingCountry() {
        const m = document.cookie.match(/(?:^|;\s*)localization=([A-Za-z]{2})/);
        return {
          cookie: m ? m[1].toUpperCase() : null,
          page: (window.Shopify && window.Shopify.country) || null,
        };
      }

      inmDecorateError(description) {
        try {
          const text = String(description || '');
          // 売り切れ系のエラーだけを対象にする（数量制限など別のエラーには触らない）
          if (!/売り切れ|sold out|Sold out/.test(text)) return description;
          const c = this.inmShippingCountry();
          const current = c.cookie || c.page;
          const ja = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;
          let names = null;
          try { names = new Intl.DisplayNames([ja ? 'ja' : 'en'], { type: 'region' }); } catch (e) {}
          const label = (x) => { try { return (names && names.of(x)) || x; } catch (e) { return x; } };
          let hint;
          if (current && current !== 'JP') {
            const changed = c.cookie && c.page && c.cookie !== c.page;
            hint = ja
              ? `（この商品は日本国内への配送専用です。現在の配送先は「${label(current)}」${changed ? `で、ページを開いたあとに「${label(c.page)}」から切り替わっています` : 'です'}。日本にお住まいの方は下のボタンで配送先を日本に戻してください）`
              : ` (This item ships within Japan only. Your shipping country is ${label(current)}. If you are in Japan, use the button below to switch back.)`;
          } else {
            hint = ja
              ? '（在庫はございます。ブラウザに保存された配送先の情報が原因の可能性がありますので、下のボタンで配送先を日本に設定し直すか、ページを再読み込みしてお試しください）'
              : ' (This item is in stock. Your saved shipping context may be stale — use the button below to reset it to Japan, or reload the page.)';
          }
          setTimeout(() => this.inmRecoveryUI(ja), 0);
          return text + hint;
        } catch (e) {
          return description;
        }
      }

      // 復旧ボタン。押すと配送先を日本に設定し直して入れ直す。
      // それでも駄目なら、原因の切り分けに要る値（配送先・通貨・カート点数）を画面に出し、
      // カートを介さずにこの商品だけ購入できるリンク（/cart/<variantId>:1）を案内する。
      inmRecoveryUI(ja) {
        try {
          const wrap = this.querySelector('.product-form__error-message-wrapper');
          if (!wrap || wrap.querySelector('.inm-recovery')) return;
          // エラー枠は横並びなので、囲みを1行占有させないとボタンが潰れる
          wrap.style.flexWrap = 'wrap';
          const box = document.createElement('div');
          box.className = 'inm-recovery';
          box.style.cssText = 'flex:1 0 100%;margin-top:0.8rem;';
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'button button--secondary';
          btn.textContent = ja ? '配送先を日本に設定して入れ直す' : 'Reset to Japan and retry';
          const status = document.createElement('p');
          status.style.cssText = 'margin:0.6rem 0 0;font-size:1.3rem;line-height:1.6;';
          box.appendChild(btn);
          box.appendChild(status);
          wrap.appendChild(box);
          btn.addEventListener('click', async () => {
            btn.disabled = true;
            status.textContent = ja ? '確認しています…' : 'Working…';
            const r = await this.inmRepair();
            if (r.ok) {
              window.location.reload();
              return;
            }
            btn.disabled = false;
            const vid = this.variantIdInput && this.variantIdInput.value;
            status.textContent = ja
              ? `自動では直せませんでした（配送先 ${r.country} / 通貨 ${r.currency} / カート ${r.count}点）。この商品だけを購入するには下のリンクをお使いください。`
              : `Couldn't fix it automatically (country ${r.country} / currency ${r.currency} / cart ${r.count}). Use the link below to buy this item.`;
            const a = document.createElement('a');
            a.href = '/cart/' + vid + ':1';
            a.textContent = ja ? 'この商品だけで購入手続きに進む' : 'Check out with this item only';
            a.style.cssText = 'display:inline-block;margin-top:0.4rem;text-decoration:underline;';
            status.appendChild(document.createElement('br'));
            status.appendChild(a);
          });
        } catch (e) {}
      }

      async inmRepair() {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const jsonPost = (url, body) =>
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
        const addOnce = async () => {
          const id = this.variantIdInput && this.variantIdInput.value;
          if (!id) return false;
          const r = await jsonPost(addUrl, { items: [{ id: Number(id), quantity: 1 }] });
          return r.ok;
        };
        const state = async () => {
          try {
            const c = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
            return { count: c.item_count, currency: c.currency };
          } catch (e) {
            return { count: '?', currency: '?' };
          }
        };
        try {
          const fd = new FormData();
          fd.append('form_type', 'localization');
          fd.append('utf8', '✓');
          fd.append('_method', 'put');
          fd.append('country_code', 'JP');
          fd.append('return_to', window.location.pathname);
          await fetch('/localization', { method: 'POST', body: fd });
          if (await addOnce()) return { ok: true };
          // カートが空のときだけ作り直す（中身がある人の買い物を消さない）
          const s1 = await state();
          if (s1.count === 0) {
            await jsonPost(cartUrl + '/clear.js', {});
            if (await addOnce()) return { ok: true };
          }
          const s2 = await state();
          return {
            ok: false,
            country: (window.Shopify && window.Shopify.country) || '?',
            currency: s2.currency,
            count: s2.count,
          };
        } catch (e) {
          return { ok: false, country: '?', currency: '?', count: '?' };
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Liquid が disabled にしたボタンからは送信しない。
        // コンストラクタが hidden input の disabled を無条件で外すため、
        // ここで止めないと「購入不可のはずの variant」で /cart/add.js が飛ぶ。
        if (this.submitButton && this.submitButton.hasAttribute('disabled')) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(this.inmDecorateError(response.description));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
